// components/ui/input.js
import './input.css';

export function Input(props) {
  return (
    <input {...props} className="custom-input" />
  );
}